module.exports = fox._r("images/press/press-header-icon.png", __webpack_public_path__ + "_/common/images/press/press-header-icon.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/press-header-icon.png
// module id = 367
// module chunks = 2